<template>
    <div class="grid">
        <div class="col-6 md:col:12 flex flex-column">
            <div class="font-bold mx-auto text-xl">{{ label('Task') }} Status</div>
            <div class="flex flex-row">
                <entity-boxes :reportType="'taskReport'" :boxType="'progress'" :chartData="dynamicTask?.progress" />
                <div class="col-12 md:col-6">
                    <base-chart :chartType="ChartTypes.PIE" :data="taskByProgressJson" :showLegend="false" />
                </div>
            </div>
        </div>
        <div class="col-6 md:col:12 flex flex-column">
            <div class="font-bold mx-auto text-xl">{{ label('Task') }} Priority</div>
            <div class="flex flex-row">
                <div class="col-12 md:col-6">
                    <base-chart :chart-type="ChartTypes.PIE" :data="taskByPriorityJson" :showLegend="false" />
                </div>
                <entity-boxes :reportType="'taskReport'" :boxType="'priority'" :chartData="dynamicTask?.priority" />
            </div>
        </div>
    </div>
</template>
<script setup>
import EntityBoxes from '../../../../../modules/amscharts/EntityBoxes.vue';
import BaseChart from '../../../../../modules/amscharts/BaseChart.vue';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { reportStore } from '../../../../../store/global-stores';
import { ChartTypes } from '../../../../../enums';
import { toCapitalize } from '../../../../../utilities';
import { colorBasedOnStatus, colorBasedOnPriority } from '../../../../../utilities/colors';
import { useLabels } from '@/composables/LabelComposable';

const { dynamicTask } = storeToRefs(reportStore);
const { label } = useLabels();
const taskByProgressJson = computed(() => {
    return dynamicTask.value?.progress?.map((dataObj) => {
        return {
            label: toCapitalize(dataObj.name),
            values: [
                {
                    value: dataObj.percentage,
                    bgcolor: colorBasedOnStatus(dataObj.name),
                },
            ],
        };
    });
});

const taskByPriorityJson = computed(() => {
    return dynamicTask.value?.priority?.map((dataObj) => {
        return {
            label: toCapitalize(dataObj.name),
            values: [
                {
                    value: dataObj.percentage,
                    bgcolor: colorBasedOnPriority(dataObj.name),
                },
            ],
        };
    });
});
</script>
